/**
 * Типизированная версия Object.fromEntries
 * @param entries массив кортежей [ключ, значение]
 * @return результирующий объект
 * @example
 * ```ts
 * const entries = [['name', 'John'], ['age', 30], ['city', 'Moscow']] as const;
 * const obj = fromEntries(entries);
 *
 * // Тип obj: { name: 'John'; age: 30; city: 'Moscow' }
 * console.log(obj.name); // 'John'
 * console.log(obj.age);  // 30
 * console.log(obj.city); // 'Moscow'
 * ```
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- any требуется в extends
export function fromEntries(entries) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return Object.fromEntries(entries);
}
